<template>
	<div v-loading="loading" id="twicedetail">
		<Header></Header>
		<div class="container">
			<div style="display:flex;">
				<div class="left-pic">
					<img v-if="srctab == false" style="width:485px;height:475px" :src="Items.album[0]">
					<img v-if="srctab == 1" style="width:485px;height:475px" v-lazy="lazyImg(album[0])">
					<img v-if="srctab == 2" style="width:485px;height:475px" v-lazy="lazyImg(album[1])">
					<img v-if="srctab == 3" style="width:485px;height:475px" v-lazy="lazyImg(album[2])">
					<img v-if="srctab == 4" style="width:485px;height:475px" v-lazy="lazyImg(album[3])">
					<div class="left-img">
						<div>
							<img v-for="(item, index) in Items.album" :key="index" ref="picDom" @click="pictab(index)"
								:class="index == 0 ? 'first-pictab' : 'pictab'" style="width:110px;height:110px"
								:src="item" v-if="index <= 3">
						</div>
					</div>
				</div>
				<div style="width:70%;margin-left:5%">
					<div style="over-flow:hidden;">
						<div class="right-container">
							<div class="name">
								{{ Items.title }}
								<div class="order-close" v-if="Items.status == 0">(用户已关闭交易)</div>
							</div>
							<div @click="outerVisible = true" class="close-trade">
								<button style="outline:none;"
									v-if="Items.status == 1 && Items.is_deal == 1">关闭交易</button>
								<button style="outline:none;"
									v-if="Items.status == 0 && Items.is_deal == 1">开启交易</button>
							</div>
						</div>
						<!--关闭交易提示框-->
						<el-dialog title="关闭交易" :visible.sync="outerVisible">
							<el-dialog width="40%" title="内层 Dialog" :visible.sync="innerVisible">
							</el-dialog>
							<div slot="footer" class="dialog-footer">
								<span style="text-algin:center">
									<img style="width:100%" src="@/assets/tu.png" alt="">
									<div v-if="Items.status == 1" class="closetrade"> 确定关闭此交易？</div>
									<div v-if="Items.status == 0" class="closetrade"> 确定开启此交易？</div>
									<span slot="footer" style="display:flex;justify-content:space-around">
										<button style="outline:none;" @click="outerVisible = false" class="closeover">取
											消</button>
										<button style="outline:none;" @click="changeStatus(Items.id, Items.status)"
											class="sure" type="primary">确 定</button>
									</span>
								</span>
							</div>
						</el-dialog>
						<!--关闭交易END-->
						<div class="buy-money">
							<div style="display:flex;width:200px" class="money">
								<div>商品价:</div>
								<div style="font-size:18px;color: #F9BE04;"><span
										style="font-size:12px">￥</span>{{ Items.sale_price }}</div>
							</div>
							<div v-if="Items.achieve_type == 2" class="buy-route">交易方式：平台担保交易</div>
							<div v-if="Items.achieve_type == 1" class="buy-route">交易方式：私下交易</div>
						</div>
						<div class="buy-money">
							<div style="width:200px" class="money">
								成色
								<img src="@/assets/wjx.png" alt="">
								<img src="@/assets/wjx.png" alt="">
								<img src="@/assets/wjx.png" alt="">
								<img src="@/assets/wjx.png" alt="">
								<img src="@/assets/wjxk.png" alt="">
							</div>
							<div class="buy-route" v-if="Items.status == 1">联系方式：{{ Items.mobile }}</div>
							<div class="buy-route" v-if="Items.status == 0">联系方式：***</div>
						</div>
						<div class="buy-money">
							<div class="money">城市：{{ Items.province }}省{{ Items.city }}市</div>
						</div>
						<div v-if="Items.bbs" class="personal-info">
							<a style="text-decoration:none" :href="'http://lt.hd199.com/user/' + Items.user_id">
								<div class="personal-img">
									<img :src="Items.bbs.user_avatar" alt="">
									<div style="font-size: 18px;color: #979797;">{{ Items.bbs.username }}</div>
								</div>
							</a>
							<div class="theme">
								<div class="theme-num">
									<div class="num">{{ Items.bbs.thread_count }}</div>
									<div class="listener">主题</div>
								</div>
								<div class="theme-num">
									<div class="num">{{ Items.bbs.fans_count }}</div>
									<div class="listener">听众</div>
								</div>
								<div style="border:none" class="theme-num">
									<div class="num">{{ Items.bbs.follow_count }}</div>
									<div class="listener">关注</div>
								</div>
							</div>
						</div>
					</div>
					<div>
						<div class="foot-platform">
							<img style="width:20px;height:20px" src="@/assets/gt.png" alt=""><span
								style="padding-left:10px;">平台担保交易需先把交易金额转给平台方支付宝XXXXX</span>
							<div class="foot-box">
								<div v-if="Items.is_favorite == 1" @click="collectShop(false)" class="collect">
									<img style="width:20px;height:20px" src="@/assets/collect.png" alt="">
									<div style="color:#F9BE04;font-size:12px;text-align:left;padding-left:10px">取消</div>
								</div>
								<div v-else @click="collectShop(true)" class="collect">
									<img style="width:20px;height:20px" src="@/assets/sc.png" alt="">
									<div style="font-size:12px;text-align:left;padding-left:10px">收藏</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
			<div style="padding-top:25px;">
				<div class="title">
					<span>详情描述</span>
				</div>
				<div v-html="Items.content" class="describe">
				</div>
			</div>
			<div style="padding-top:25px;">
				<div class="title">
					<span>评论({{ totals.total }})</span>
				</div>
				<div v-for="item in comment" v-bind:key="item.id">
					<div class="list-box">
						<div class="comment-box">
							<a style="text-decoration:none" :href="'http://lt.hd199.com/user/' + item.user_id">
								<div class="comment-pic">
									<div><img :src="item.bbs.user_avatar" alt=""></div>
								</div>
							</a>
							<div>

								<div class="comment-name"><a style="text-decoration:none"
										:href="'http://lt.hd199.com/user/' + item.user_id">
										<span>{{ item.bbs.user_name }}</span></a> &nbsp{{ item.content }}</div>
								<div class="time">{{ item.create_time | time }}</div>
							</div>
						</div>
						<div class="msg" @click="reply(item.id)">
							<img style="width:24;height:20px" src="@/assets/send.png" alt="">
						</div>
					</div>
					<div v-for="items in item._children" v-bind:key="items.id" class="list-box">
						<div style="margin-left:50px" class="comment-box">
							<div class="comment-pic">
								<div><img :src="items.bbs.user_avatar" alt=""></div>
							</div>
							<div>
								<div class="comment-name">
									{{ items.bbs.user_name }}<span></span>回复<span>{{ item.bbs.user_name }}</span>
									&nbsp{{ items.content }}</div>
								<div class="time">{{ items.create_time | time }}</div>
							</div>
						</div>
					</div>
				</div>
				<div v-if="comment.length != 0" class="pagination">
					<el-pagination background @current-change="changePage" :current-page="bbs_page.current_page"
						:page-size="10" layout="prev, pager, next" :total="bbs_page.total">
					</el-pagination>
					<span>共{{ pagenum.last_page }}页</span>
				</div>
				<div v-show="!isShowLogin" class="send-box">
					<div>
						<img :src="avatar_url" alt="">
					</div>

					<div v-show="!isShowLogin" class="text-input">
						<textarea placeholder="请输入评论" v-model="text" name="" id="" cols="" rows="16"></textarea>
					</div>
				</div>
				<div v-show="!isShowLogin" class="foot-button"> <button style="outline:none;" :disabled='disabled'
						@click="sendComment">发表评论</button></div>
			</div>
		</div>
		<ReturnBox :ReturnBoxDialog.sync="ReturnBoxDialog" :parent_id="parent_id" :goods_id="Items.id"
			:avatar="avatar_url"></ReturnBox>
		<Foot></Foot>
	</div>
</template>
<script>
import axios from 'axios'
import Foot from '@/components/common/Foot'
import Header from '@/components/twicehands/Header'
import ReturnBox from '@/components/common/ReturnBox'
import { tabSwitch, getCookie } from '@/common/js/common'
import Mixin from '@/common/js/mixin'
export default {
	mixins: [Mixin],
	name: 'detail',
	data() {
		return {
			avatar_url: localStorage.getItem('user_info') ? JSON.parse(localStorage.getItem('user_info')).avatar_url : '',
			Items: {},
			shop: [],
			comment: [],
			child: [],
			dialogVisible: false,
			condition: [],
			brand: [],
			video: [],
			fileList: [{}],
			outerVisible: false,
			innerVisible: false,
			text: '',
			ReturnBoxDialog: false, //回复框状态
			parent_id: '',//父级评论ID
			totals: [],  //评论次数
			srctab: false, //图片显示大图
			album: [],
			disabled: false,
			total: 0,
			current_page: 0,
			page: 1,
			bbs_page: {
				total: 0,
				current_page: 0,
				page: 1,
			},
			pagenum: [],
			loading: true,  //加载
			isShowLogin: true,//是否登录
		};
	},
	components: {
		Foot,
		Header,
		ReturnBox
	},
	created() {
		this.getDetail()
		this.getCommentList()
		this.isLogin()
		axios({
			'url': 'http://lt.hd199.com/api/v3/user',
			method: 'get',
			params: {
				userId: getCookie("user") ? getCookie("user") : getCookie("dzq_user_id")
			},

		}).then(res => {
			this.avatar_url = res.Data.avatarUrl
		})
	},
	methods: {
		isLogin() {
			if (getCookie("sid")) {
				this.isShowLogin = false;
			}
		},
		// 回复评论
		reply(id) {
			if (getCookie("sid")) {
				this.parent_id = id;
				this.ReturnBoxDialog = true;
			} else {
				//未登陆
				this.$message({
					type: 'error',
					message: '请登录后再评论'
				});
			}
		},
		// 获取详情
		getDetail() {
			
			this.$get(`/apis/idle/idle/${this.$route.query.id}?uid=${getCookie("user")}`).then((res) => {
				if (res) {
					this.Items = res.data
					this.album = res.data.album
					this.loading = false;
				}
			})
		},
		// 评论列表
		getCommentList: function () {
			this.$get('/apis/idle/IdleGoodsComment', {
				params: {
					goods_id: this.$route.query.id,
					order: 'create_time asc',
					type: 1,
					page: this.bbs_page.page
				}
			}).then((res) => {
				if (res) {
					this.comment = res.data.data
					this.bbs_page.total = res.data.total;
					this.bbs_page.current_page = res.data.current_page;
					this.totals = res.data
					this.pagenum = res.data
				}
			})
		},
		changePage(currentPage) {
			this.bbs_page.page = currentPage;
			this.getCommentList();
		},
		pictab(index) {
			this.srctab = index + 1
			tabSwitch(this, index, 'picDom');
		},
		// 改变交易状态
		changeStatus(id, sta) {
			let status = sta == 1 ? 0 : 1;
			this.$get('/apis/idle/status/id/' + id + '/status/' + status).then((res) => {

				if (res) {
					this.outerVisible = false
					this.getDetail()
					this.getCommentList()
				}
			})
		},
		// 添加收藏 取消收藏
		collectShop(value) {
			if (value === true) {
				this.$post('/apis/idle/idleFavorite', {
					user_id: getCookie("user") ? getCookie("user") : getCookie("dzq_user_id"),
					goods_id: this.$route.query.id
				}).then((res) => {
					if (res) {
						this.$message({
							message: '收藏成功',
							type: 'success',
							onClose: () => {
								this.getDetail()
							}
						});
					}
				})
			} else {
				this.$_delete('/apis/idle/idleFavorite/' + this.$route.query.id + '?uid=' + getCookie("user") ? getCookie("user") : getCookie("dzq_user_id")).then((res) => {
					if (res) {
						this.$message({
							message: '取消收藏成功',
							type: 'success',
							onClose: () => {
								this.getDetail()
							}
						});
					}
				})
			}
		},
		// 发表评论
		sendComment() {
			this.disabled = true
			if (this.text == '') {
				this.$message({
					type: 'error',
					message: '输入内容不能为空',
				})
				this.disabled = false
			} else {
				this.$post('/apis/idle/IdleGoodsComment', {
					goods_id: this.$route.query.id,
					content: this.text,
					user_id: getCookie("user") ? getCookie("user") : getCookie("dzq_user_id"),
					type: 1
				}).then((res) => {
					if (res) {
						this.$message({
							message: '评论成功',
							type: 'success',
							onClose: () => {
								setTimeout(() => {
									this.disabled = false
									this.getCommentList()
									this.text = ''
								}
									, 2000)
								this.disabled = true
							}
						});
					}
				})
			}
		}
	}
}
</script>

<style>
body {
	margin: 0px;
}

#twicedetail {
	min-width: 1200px;
}

.el-submenu .el-menu {
	z-index: 1;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
	background: rgba(0, 0, 0, 0.00);
	border: 1px solid #F9BE04;
}

.el-pagination.is-background .el-pager li {
	border: 1px solid #D5D5D5;
	color: #D5D5D5;
}

#twicedetail .pagination {
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 20px;
	margin-bottom: 20px;
}

.order-close {
	font-size: 14px;
	color: #F9BE04;
	display: inline-block;
}

#twicedetail .pagination input {
	width: 28px;
	border: 1px solid #D5D5D5;
	height: 26px;
	margin-left: 4px;
	margin-right: 4px;
}

#twicedetail .pagination span {
	font-size: 14px;
	color: #D5D5D5;
	letter-spacing: 0;
	line-height: 18px;
	margin-left: 11px;
}

#twicedetail .pagination-button {
	color: #fff;
	background: #F9BE04;
	box-shadow: 0 2px 4px 0 rgba(200, 200, 200, 0.50);
	border-radius: 2px 2px 2px 0 2px;
	border: none;
	height: 30px;
	width: 65px;
	margin-left: 8px;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
	background: #F9BE04;
}

#twicedetail .container {
	box-sizing: border-box;
	width: 1200px;
	margin: auto;
	overflow: hidden;
	margin-top: 35px;
}

#twicedetail .right-container {
	display: flex;
	justify-content: space-between;
	line-height: 50px;
}

#twicedetail .name {
	font-size: 28px;
	color: #232323;
}

#twicedetail .close-trade button {
	background: #F9BE04;
	box-shadow: 0 2px 4px 0 rgba(200, 200, 200, 0.50);
	border-radius: 2px 2px 2px 0 2px;
	border: none;
	color: #fff;
	height: 26px;
	width: 84px;
	cursor: pointer;
}

#twicedetail .money {
	font-size: 18px;
	color: #232323
}

#twicedetail .pictab {
	border: 1px solid #fff;
}

#twicedetail .first-pictab {
	border: 1px solid #F9BE04;
}

#twicedetail .money span {
	font-size: 36px;
	color: #F9BE04;
}

#twicedetail .buy-route {
	margin-left: 100px;
	width: 200px;
	font-size: 14px;
}

#twicedetail .buy-money {
	display: flex;
	line-height: 60px;

}

#twicedetail .personal-info {
	background: #fbfbfb;
	box-shadow: 0 2px 4px 0 rgba(212, 212, 212, 0.50);
	height: 150px;
	margin-top: 35px;

}

#twicedetail .personal-img {
	text-align: center
}

#twicedetail .personal-img img {
	width: 53px;
	height: 53px;
	border-radius: 27px;
	margin-top: 10px;
}

#twicedetail .theme {
	display: flex;
	margin-top: 10px;
	color: #979797;
}

#twicedetail .theme-num {
	width: 33%;
	text-align: center;
	border-right: 1px solid #979797;
	margin: auto;
}

#twicedetail .num {
	font-size: 14px;
}

#twicedetail .listener {
	font-size: 12px;
}

#twicedetail .left-img {
	display: flex;
	width: 485px;
	margin-top: 20px;
}

#twicedetail .left-img img {
	height: 103px;
	width: 103px;
	margin-left: 5px;
}

#twicedetail .foot-platform {
	font-size: 12px;
	color: #F9BE04;
	display: flex;
	align-items: center;
	line-height: 40px;
}

#twicedetail .collect {
	font-size: 18px;
	color: #5E5E5E;
	text-align: center;
	cursor: pointer;
	min-width: 36px;
	display: flex;
	align-items: center;
}

#twicedetail .foot-box {
	display: flex;
	justify-content: space-between;
	float: right;
	margin-left: 35%;
}

#twicedetail .concact-customer button {
	background: #F9BE04;
	box-shadow: 0 2px 4px 0 rgba(200, 200, 200, 0.50);
	border-radius: 2px;
	border: none;
	color: #fff;
	height: 44px;
	width: 138px;
}

.el-dialog__header {
	background: #F9BE04;
	padding: 16px 20px;
}

.dialog-footer {
	display: flex;
	justify-content: space-around;
}

#twicedetail .closetrade {
	text-align: center;
	font-size: 20px;
	color: #000000;
	padding-bottom: 50px;
}

#twicedetail .sure {
	background: #F9C213;
	box-shadow: 0 2px 4px 0 rgba(198, 198, 198, 0.50);
	border-radius: 2px;
	border: none;
	height: 37px;
	width: 180px;
	font-size: 18px;
	color: #FFFFFF;
}

#twicedetail .closeover {
	background: #CFCFCF;
	box-shadow: 0 2px 4px 0 rgba(198, 198, 198, 0.50);
	border-radius: 2px;
	height: 37px;
	width: 180px;
	font-size: 18px;
	color: #FFFFFF;
	border: none;
}

.el-icon-close:before {
	color: black
}

#twicedetail .first-select {
	border: 1px solid #F9C213
}

#twicedetail .tabimg :active {
	border: 1px solid #F9C213;
}

#twicedetail .title {
	background: #fbfbfb;
	height: 53px;
	border-left: 5px solid #F9BE04;
	width: 100%;
	line-height: 53px;
}

#twicedetail .title span {
	font-size: 20px;
	color: #2E2E2E;
	margin-left: 18px
}

#twicedetail .describe {
	font-size: 12px;
	color: #2E2E2E;
	margin-left: 23px;
	padding-top: 10px;
}

#twicedetail .title {
	background: #fbfbfb;
	height: 53px;
	border-left: 5px solid #F9BE04;
	width: 100%;
	line-height: 53px;
}

#twicedetail .title span {
	font-size: 20px;
	color: #2E2E2E;
	margin-left: 18px
}

#twicedetail .comment-pic {
	margin-left: 23px;
	padding-top: 9px;
	padding-bottom: 9px
}

#twicedetail .comment-pic img {
	width: 36px;
	height: 36px;
	border-radius: 18px
}

#twicedetail .comment-box {
	display: flex;
	justify-content: flex-start;
}

#twicedetail .time {
	font-size: 12px;
	color: #C4C4C4;
	margin-left: 13px
}

#twicedetail .comment-name {
	font-size: 16px;
	color: #232323;
	line-height: 22px;
	margin-left: 13px;
	margin-top: 9px;
}

#twicedetail .comment-name span {
	color: #F9BE04
}

#twicedetail .list-box {
	display: flex;
	justify-content: space-between;
	border-bottom: 1px solid #e8e8e8;
	border-left: 1px solid #e8e8e8;
	border-right: 1px solid #e8e8e8;
}

#twicedetail .msg {
	margin-right: 30px;
	margin-top: 20px;
}

#twicedetail .send-box {
	display: flex;
	margin-top: 52px;
}

#twicedetail .send-box img {
	width: 58px;
	height: 58px;
}

#twicedetail .text-input {
	margin-left: 20px;
	width: 100%;
}

#twicedetail .text-input textarea {
	width: 99%;
}

#twicedetail .foot-button {
	display: flex;
	justify-content: flex-end;
	margin-top: 18px;
	padding-bottom: 20px;
}

#twicedetail .foot-button button {
	background: #F9BE04;
	box-shadow: 0 2px 4px 0 rgba(200, 200, 200, 0.50);
	border-radius: 2px;
	border: none;
	color: #fff;
	width: 138px;
	height: 44px;
	cursor: pointer;
}

#twicedetail .titled {
	height: 60px;
	width: 100%;
	background: #272727;
	display: flex;
	justify-content: space-between;
	align-items: center
}

#twicedetail .title-tab {
	display: flex;
}

#twicedetail .title-tab div {
	color: #fff;
	padding-left: 45px;
	font-size: 16px;
	line-height: 40px;
}

#twicedetail .vertical {
	width: 1px;
	background: #fff;
	opacity: 0.4;
	margin-left: 11px
}

#twicedetail .login-me {
	color: #fff;
	font-size: 16;
	display: flex;
	margin-right: 160px；
}

#twicedetail .login-me img {
	height: 14px;
	width: 14px;
}

#twicedetail .login-me div {
	margin-right: 37px;
	display: flex;
	align-items: center;
	cursor: pointer;
	line-height: 19px;
}

#twicedetail .login-me span {
	margin-left: 8px;
	margin-top: -3px;
	color: #fff;
	font-size: 14px;
}

.el-icon-close:before {
	color: black
}

.el-dialog {
	width: 40%;
}

.el-dialog__header {
	background: #F9BE04;
	padding: 16px 20px;
}

.el-textarea__inner {
	height: 150px;
}

#twicedetail .classifys {
	display: flex;
	font-size: 18px;
	color: #303030;
	margin-top: 30px;
	display: flex;
	padding-left: 15px;
	align-items: center;
}

#twicedetail .class-list {
	display: flex;
}

#twicedetail .select {
	border: 1px solid #D3D3D2;
	border-radius: 8px;
	padding: 0 12px;
	font-size: 12px;
	color: #D3D3D2;
	margin-left: 20px;
}

#twicedetail .first-select {
	border: 1px solid #F9BE04;
	border-radius: 8px;
	color: #F9BE04;
	margin-left: 20px;
	padding: 0 12px;
	font-size: 12px;
}

.el-checkbox__label {
	font-size: 16px;
	color: #BCBCBC;
}

.el-checkbox__input.is-checked+.el-checkbox__label {
	color: #F9BF07;
}

.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
	background: #F9BF07;
	border-color: #F9C00B;
}

.el-checkbox__inner:hover {
	border-color: #F9C00B;
}

.el-checkbox__input.is-focus.el-checkbox__inner {
	border-color: #F9C00B;
}

#twicedetail .load-button {
	background: #F9C213;
	box-shadow: 0 2px 4px 0 rgba(198, 198, 198, 0.50);
	border-radius: 2px;
	border: none;
	color: #fff;
	width: 110px;
	height: 37px;
	margin-left: 3px;
	font-size: 18px;
}

.el-textarea {
	width: 80%;
}

.dialog-footer {
	display: flex;
	justify-content: center;
}

.dialog-footer button {
	border: none;
	background: #F9C213;
	box-shadow: 0 2px 4px 0 rgba(198, 198, 198, 0.50);
	border-radius: 2px;
	height: 37px;
	width: 142px;
	color: #fff;
	font-size: 18px;
	margin-left: -100px;
	margin-right: -100px;
}

.el-submenu {
	position: absolute;
	top: -28px;
	background: #272727;
	width: 110px;
}

.el-menu-item.is-active {
	color: #F9C213;
}

.el-submenu__title:hover {
	background: #272727;
}

.el-submenu__title {
	padding: 0 !important;
}

.el-submenu .el-menu-item {
	padding: 0 !important;
	min-width: 0;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/twicehands/Detail.vue